import script from "./single-color-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./single-color-picker.vue?vue&type=script&setup=true&lang=ts"

import "./single-color-picker.vue?vue&type=style&index=0&id=13cb310d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13cb310d"]])

export default __exports__